import React from 'react';

export const getNotificationIcon = (type: string) => {
  switch (type) {
    case 'HiddenPost':
    case 'AdminDeletePostInGroup':
    case 'AdminDeletePostInFanpage':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.725 5.3785C10.6691 5.3785 10.2375 4.63183 10.7625 3.716C11.0658 3.18517 10.885 2.5085 10.3541 2.20517L9.34496 1.62767C8.88413 1.3535 8.28913 1.51683 8.01496 1.97767L7.95079 2.0885C7.42579 3.00433 6.56246 3.00433 6.03163 2.0885L5.96746 1.97767C5.70496 1.51683 5.10996 1.3535 4.64913 1.62767L3.63996 2.20517C3.10913 2.5085 2.92829 3.191 3.23163 3.72183C3.76246 4.63183 3.33079 5.3785 2.27496 5.3785C1.66829 5.3785 1.16663 5.87433 1.16663 6.48683V7.5135C1.16663 8.12017 1.66246 8.62183 2.27496 8.62183C3.33079 8.62183 3.76246 9.3685 3.23163 10.2843C2.92829 10.8152 3.10913 11.4918 3.63996 11.7952L4.64913 12.3727C5.10996 12.6468 5.70496 12.4835 5.97913 12.0227L6.04329 11.9118C6.56829 10.996 7.43163 10.996 7.96246 11.9118L8.02663 12.0227C8.30079 12.4835 8.89579 12.6468 9.35663 12.3727L10.3658 11.7952C10.8966 11.4918 11.0775 10.8093 10.7741 10.2843C10.2433 9.3685 10.675 8.62183 11.7308 8.62183C12.3375 8.62183 12.8391 8.126 12.8391 7.5135V6.48683C12.8333 5.88017 12.3375 5.3785 11.725 5.3785ZM6.99996 8.896C5.95579 8.896 5.10413 8.04433 5.10413 7.00017C5.10413 5.956 5.95579 5.10433 6.99996 5.10433C8.04413 5.10433 8.89579 5.956 8.89579 7.00017C8.89579 8.04433 8.04413 8.896 6.99996 8.896Z"
            fill="white"
          />
        </svg>
      );
    case 'CreatePost':
    case 'CreatePostInGroup':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.632 2.93253C14.1545 2.22007 14.116 1.11308 13.546 0.45999C12.976 -0.193096 12.0904 -0.144966 11.568 0.567492L4.85602 9.72016L2.38995 6.63757C1.84321 5.95415 0.956783 5.95415 0.41005 6.63757C-0.136683 7.32099 -0.136683 8.42902 0.41005 9.11244L3.91005 13.4874C4.18006 13.825 4.54865 14.01 4.93041 13.9996C5.31217 13.9892 5.67398 13.7844 5.93201 13.4325L13.632 2.93253Z"
            fill="white"
          />
        </svg>
      );
    case 'LikePost':
    case 'LikeComment':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.89417 10.7859V4.85925C4.89417 4.62592 4.96416 4.39842 5.0925 4.20592L6.685 1.83759C6.93583 1.45842 7.56 1.19009 8.09083 1.38842C8.6625 1.58092 9.04166 2.22259 8.91916 2.79425L8.61583 4.70175C8.5925 4.87675 8.63916 5.03425 8.73833 5.15675C8.8375 5.26759 8.98333 5.33759 9.14083 5.33759H11.5383C11.9992 5.33759 12.3958 5.52425 12.6292 5.85092C12.8508 6.16592 12.8917 6.57425 12.7458 6.98842L11.3108 11.3576C11.13 12.0809 10.3425 12.6701 9.56083 12.6701H7.28583C6.895 12.6701 6.34666 12.5359 6.09583 12.2851L5.34916 11.7076C5.06333 11.4918 4.89417 11.1476 4.89417 10.7859Z"
            fill="white"
          />
          <path
            d="M3.03925 3.72168H2.43841C1.53425 3.72168 1.16675 4.07168 1.16675 4.93501V10.8033C1.16675 11.6667 1.53425 12.0167 2.43841 12.0167H3.03925C3.94341 12.0167 4.31091 11.6667 4.31091 10.8033V4.93501C4.31091 4.07168 3.94341 3.72168 3.03925 3.72168Z"
            fill="white"
          />
        </svg>
      );
    case 'UnLikePost':
    case 'UnLikeComment':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.10592 3.20839V9.13505C9.10592 9.36838 9.03592 9.59589 8.90759 9.78839L7.31509 12.1567C7.06426 12.5359 6.44009 12.8042 5.90926 12.6059C5.33759 12.4134 4.95842 11.7717 5.08092 11.2001L5.38426 9.29255C5.40759 9.11755 5.36092 8.96005 5.26176 8.83755C5.16259 8.72672 5.01676 8.65672 4.85926 8.65672H2.46176C2.00092 8.65672 1.60426 8.47005 1.37092 8.14339C1.14926 7.82839 1.10842 7.42005 1.25426 7.00589L2.68926 2.63672C2.87009 1.91339 3.65759 1.32422 4.43926 1.32422H6.71426C7.10509 1.32422 7.65342 1.45839 7.90426 1.70922L8.65092 2.28672C8.93676 2.50839 9.10592 2.84672 9.10592 3.20839Z"
            fill="white"
          />
          <path
            d="M10.9609 10.2726H11.5617C12.4659 10.2726 12.8334 9.92257 12.8334 9.05923V3.19673C12.8334 2.3334 12.4659 1.9834 11.5617 1.9834H10.9609C10.0567 1.9834 9.68921 2.3334 9.68921 3.19673V9.06507C9.68921 9.92257 10.0567 10.2726 10.9609 10.2726Z"
            fill="white"
          />
        </svg>
      );
    case 'Comment':
    case 'ReplyComment':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.33329 1.1665H4.66663C2.33329 1.1665 1.16663 2.33317 1.16663 4.6665V12.2498C1.16663 12.5707 1.42913 12.8332 1.74996 12.8332H9.33329C11.6666 12.8332 12.8333 11.6665 12.8333 9.33317V4.6665C12.8333 2.33317 11.6666 1.1665 9.33329 1.1665ZM8.16663 8.89567H4.08329C3.84413 8.89567 3.64579 8.69734 3.64579 8.45817C3.64579 8.219 3.84413 8.02067 4.08329 8.02067H8.16663C8.40579 8.02067 8.60413 8.219 8.60413 8.45817C8.60413 8.69734 8.40579 8.89567 8.16663 8.89567ZM9.91663 5.979H4.08329C3.84413 5.979 3.64579 5.78067 3.64579 5.5415C3.64579 5.30234 3.84413 5.104 4.08329 5.104H9.91663C10.1558 5.104 10.3541 5.30234 10.3541 5.5415C10.3541 5.78067 10.1558 5.979 9.91663 5.979Z"
            fill="white"
          />
        </svg>
      );
    case 'Share':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5617 5.99879L9.93672 8.62379C9.85274 8.70406 9.74117 8.74908 9.625 8.74957C9.56694 8.74931 9.50943 8.73818 9.45547 8.71675C9.37584 8.68328 9.30791 8.627 9.26022 8.55498C9.21253 8.48296 9.18723 8.39844 9.1875 8.31207V6.12457C8.1204 6.12369 7.08335 6.47791 6.23976 7.1314C5.39616 7.78489 4.79399 8.70049 4.52813 9.73394C4.50291 9.82788 4.44748 9.91091 4.37038 9.97021C4.29329 10.0295 4.19882 10.0618 4.10156 10.0621L3.99219 10.0457C3.88086 10.0161 3.78569 9.94379 3.72733 9.84448C3.66897 9.74517 3.65213 9.62684 3.68047 9.51519C3.99485 8.29385 4.70662 7.2118 5.70366 6.43952C6.7007 5.66723 7.92634 5.2486 9.1875 5.24957V3.06207C9.18723 2.97569 9.21253 2.89117 9.26022 2.81916C9.30791 2.74714 9.37584 2.69085 9.45547 2.65738C9.53628 2.62586 9.62436 2.61786 9.70953 2.63432C9.79469 2.65077 9.87346 2.691 9.93672 2.75035L12.5617 5.37535C12.6439 5.4583 12.69 5.57032 12.69 5.68707C12.69 5.80381 12.6439 5.91584 12.5617 5.99879V5.99879ZM10.5 11.3746H2.1875V4.81207C2.1875 4.69603 2.14141 4.58475 2.05936 4.50271C1.97731 4.42066 1.86603 4.37457 1.75 4.37457C1.63397 4.37457 1.52269 4.42066 1.44064 4.50271C1.35859 4.58475 1.3125 4.69603 1.3125 4.81207V11.3746C1.3125 11.6066 1.40469 11.8292 1.56878 11.9933C1.73288 12.1574 1.95544 12.2496 2.1875 12.2496H10.5C10.616 12.2496 10.7273 12.2035 10.8094 12.1214C10.8914 12.0394 10.9375 11.9281 10.9375 11.8121C10.9375 11.696 10.8914 11.5848 10.8094 11.5027C10.7273 11.4207 10.616 11.3746 10.5 11.3746Z"
            fill="white"
          />
        </svg>
      );
    case 'FriendRequest':
    case 'AcceptFriend':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.99996 1.1665C5.47163 1.1665 4.22913 2.409 4.22913 3.93734C4.22913 5.4365 5.40163 6.64984 6.92996 6.70234C6.97663 6.6965 7.02329 6.6965 7.05829 6.70234C7.06996 6.70234 7.07579 6.70234 7.08746 6.70234C7.09329 6.70234 7.09329 6.70234 7.09913 6.70234C8.59246 6.64984 9.76496 5.4365 9.77079 3.93734C9.77079 2.409 8.52829 1.1665 6.99996 1.1665Z"
            fill="white"
          />
          <path
            d="M9.96331 8.25418C8.33581 7.16918 5.68164 7.16918 4.04248 8.25418C3.30164 8.75001 2.89331 9.42085 2.89331 10.1383C2.89331 10.8558 3.30164 11.5208 4.03664 12.0108C4.85331 12.5592 5.92664 12.8333 6.99998 12.8333C8.07331 12.8333 9.14664 12.5592 9.96331 12.0108C10.6983 11.515 11.1066 10.85 11.1066 10.1267C11.1008 9.40918 10.6983 8.74418 9.96331 8.25418Z"
            fill="white"
          />
        </svg>
      );
    case 'Chat':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.91663 1.1665H4.08329C2.47329 1.1665 1.16663 2.46734 1.16663 4.0715V7.55984V8.14317C1.16663 9.74734 2.47329 11.0482 4.08329 11.0482H4.95829C5.11579 11.0482 5.32579 11.1532 5.42496 11.2815L6.29996 12.4423C6.68496 12.9557 7.31496 12.9557 7.69996 12.4423L8.57496 11.2815C8.68579 11.1357 8.86079 11.0482 9.04163 11.0482H9.91663C11.5266 11.0482 12.8333 9.74734 12.8333 8.14317V4.0715C12.8333 2.46734 11.5266 1.1665 9.91663 1.1665ZM4.66663 6.99984C4.33996 6.99984 4.08329 6.73734 4.08329 6.4165C4.08329 6.09567 4.34579 5.83317 4.66663 5.83317C4.98746 5.83317 5.24996 6.09567 5.24996 6.4165C5.24996 6.73734 4.99329 6.99984 4.66663 6.99984ZM6.99996 6.99984C6.67329 6.99984 6.41663 6.73734 6.41663 6.4165C6.41663 6.09567 6.67913 5.83317 6.99996 5.83317C7.32079 5.83317 7.58329 6.09567 7.58329 6.4165C7.58329 6.73734 7.32663 6.99984 6.99996 6.99984ZM9.33329 6.99984C9.00663 6.99984 8.74996 6.73734 8.74996 6.4165C8.74996 6.09567 9.01246 5.83317 9.33329 5.83317C9.65413 5.83317 9.91663 6.09567 9.91663 6.4165C9.91663 6.73734 9.65996 6.99984 9.33329 6.99984Z"
            fill="white"
          />
        </svg>
      );
    case 'DonatePost':
    case 'DonateCreator':
    case 'SystemDonatePost':
    case 'SystemDonateCreator':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.41251 6.29987L4.90001 9.18737L7.67084 8.04987L8.95417 4.3457L4.63751 4.57904L3.41251 6.29987Z"
            fill="#E69329"
          />
          <path
            d="M4.37501 12.7751C5.63145 12.7751 6.65001 11.7565 6.65001 10.5001C6.65001 9.24365 5.63145 8.2251 4.37501 8.2251C3.11856 8.2251 2.10001 9.24365 2.10001 10.5001C2.10001 11.7565 3.11856 12.7751 4.37501 12.7751Z"
            fill="#546E7A"
          />
          <path
            d="M4.375 7.875C2.91667 7.875 1.75 9.04167 1.75 10.5C1.75 11.9583 2.91667 13.125 4.375 13.125C5.83333 13.125 7 11.9583 7 10.5C7 9.04167 5.83333 7.875 4.375 7.875ZM4.375 12.5417C3.2375 12.5417 2.33333 11.6375 2.33333 10.5C2.33333 9.3625 3.2375 8.45833 4.375 8.45833C5.5125 8.45833 6.41667 9.3625 6.41667 10.5C6.41667 11.6375 5.5125 12.5417 4.375 12.5417Z"
            fill="#90A4AE"
          />
          <path
            d="M4.08333 9.625H4.66666V11.9583H4.08333V9.625Z"
            fill="#90A4AE"
          />
          <path
            d="M3.76251 10.5C4.05417 11.0541 4.69584 11.2875 5.25001 10.9958L10.0625 8.51663C10.3542 8.3708 10.5583 8.16663 10.7042 7.96247C11.2 7.02913 12.3375 4.84163 13.0958 2.9458L7.78751 5.4833L6.38751 7.5833L4.40417 8.6333C3.64584 9.01247 3.41251 9.8583 3.76251 10.5Z"
            fill="#FFB74D"
          />
          <path
            d="M8.80834 0.875L3.99584 2.7125C3.79167 2.77083 3.55834 3.00417 3.35417 3.20833L1.72084 5.39583C1.42917 5.83333 1.37084 6.3875 1.575 6.88333C1.69167 7.175 2.07084 7.875 2.47917 8.6625C2.94584 8.16667 3.61667 7.875 4.375 7.875C4.49167 7.875 4.6375 7.875 4.75417 7.90417L4.14167 6.67917L5.48334 5.48333H7.81667C7.81667 5.48333 12.3375 4.84167 13.125 2.94583L8.80834 0.875Z"
            fill="#FFB74D"
          />
          <path
            d="M5.30833 10.4999C4.92916 10.6749 4.49166 10.4999 4.34583 10.1208C4.17083 9.74162 4.34583 9.30411 4.725 9.15828C5.075 8.98328 5.65833 10.3249 5.30833 10.4999Z"
            fill="#FFCDD2"
          />
        </svg>
      );
    case 'InviteJoinGroup':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.2259 4.53234C10.185 4.5265 10.1442 4.5265 10.1034 4.53234C9.19919 4.50317 8.48169 3.76234 8.48169 2.85234C8.48169 1.92484 9.23419 1.1665 10.1675 1.1665C11.095 1.1665 11.8534 1.919 11.8534 2.85234C11.8475 3.76234 11.13 4.50317 10.2259 4.53234Z"
            fill="white"
          />
          <path
            d="M12.1275 8.57524C11.4742 9.01274 10.5583 9.17607 9.71252 9.06524C9.93418 8.5869 10.0508 8.05607 10.0567 7.49607C10.0567 6.91274 9.92835 6.35857 9.68335 5.8744C10.5467 5.75774 11.4625 5.92107 12.1217 6.35857C13.0433 6.96524 13.0434 7.96274 12.1275 8.57524Z"
            fill="white"
          />
          <path
            d="M3.75668 4.53234C3.79751 4.5265 3.83834 4.5265 3.87918 4.53234C4.78334 4.50317 5.50084 3.76234 5.50084 2.85234C5.50084 1.919 4.74834 1.1665 3.81501 1.1665C2.88751 1.1665 2.13501 1.919 2.13501 2.85234C2.13501 3.76234 2.85251 4.50317 3.75668 4.53234Z"
            fill="white"
          />
          <path
            d="M3.82078 7.49569C3.82078 8.06152 3.94328 8.59819 4.16495 9.08236C3.34245 9.16986 2.48495 8.99486 1.85495 8.58069C0.93328 7.96819 0.93328 6.97069 1.85495 6.35819C2.47911 5.93819 3.35995 5.76902 4.18828 5.86236C3.94911 6.35236 3.82078 6.90652 3.82078 7.49569Z"
            fill="white"
          />
          <path
            d="M7.07005 9.2575C7.02338 9.25167 6.97088 9.25167 6.91838 9.2575C5.84505 9.2225 4.98755 8.34167 4.98755 7.25667C4.99338 6.14833 5.88588 5.25 7.00005 5.25C8.10838 5.25 9.00671 6.14833 9.00671 7.25667C9.00088 8.34167 8.14922 9.2225 7.07005 9.2575Z"
            fill="white"
          />
          <path
            d="M5.17417 10.465C4.29334 11.0542 4.29334 12.0225 5.17417 12.6059C6.17751 13.2767 7.82251 13.2767 8.82584 12.6059C9.70668 12.0167 9.70668 11.0484 8.82584 10.465C7.82834 9.79421 6.18334 9.79421 5.17417 10.465Z"
            fill="white"
          />
        </svg>
      );
    default:
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.725 5.3785C10.6691 5.3785 10.2375 4.63183 10.7625 3.716C11.0658 3.18517 10.885 2.5085 10.3541 2.20517L9.34496 1.62767C8.88413 1.3535 8.28913 1.51683 8.01496 1.97767L7.95079 2.0885C7.42579 3.00433 6.56246 3.00433 6.03163 2.0885L5.96746 1.97767C5.70496 1.51683 5.10996 1.3535 4.64913 1.62767L3.63996 2.20517C3.10913 2.5085 2.92829 3.191 3.23163 3.72183C3.76246 4.63183 3.33079 5.3785 2.27496 5.3785C1.66829 5.3785 1.16663 5.87433 1.16663 6.48683V7.5135C1.16663 8.12017 1.66246 8.62183 2.27496 8.62183C3.33079 8.62183 3.76246 9.3685 3.23163 10.2843C2.92829 10.8152 3.10913 11.4918 3.63996 11.7952L4.64913 12.3727C5.10996 12.6468 5.70496 12.4835 5.97913 12.0227L6.04329 11.9118C6.56829 10.996 7.43163 10.996 7.96246 11.9118L8.02663 12.0227C8.30079 12.4835 8.89579 12.6468 9.35663 12.3727L10.3658 11.7952C10.8966 11.4918 11.0775 10.8093 10.7741 10.2843C10.2433 9.3685 10.675 8.62183 11.7308 8.62183C12.3375 8.62183 12.8391 8.126 12.8391 7.5135V6.48683C12.8333 5.88017 12.3375 5.3785 11.725 5.3785ZM6.99996 8.896C5.95579 8.896 5.10413 8.04433 5.10413 7.00017C5.10413 5.956 5.95579 5.10433 6.99996 5.10433C8.04413 5.10433 8.89579 5.956 8.89579 7.00017C8.89579 8.04433 8.04413 8.896 6.99996 8.896Z"
            fill="white"
          />
        </svg>
      );
  }
};
